import { pickBy } from "lodash";
import { DroppedFilesGridData } from "../../../@types/rldynamicanalysis";

export const pickLocalItems = (items: Record<string, DroppedFilesGridData>) =>
  pickBy(items, (element: DroppedFilesGridData) => Boolean(element.sample));
